export default __webpack_public_path__ + "static/media/user_menu.405b3e79.svg";